export enum EnvName {
  LOCAL = 'local',
  DEV = 'development',
  STAGING = 'staging',
  DEMO = 'demo',
  PROD = 'production',
}

const envName = import.meta.env.VITE_APP_BUILD_ENV as EnvName

/** True when the REST base URL points at this machine (dev server on loopback). */
export function isRestApiLocalBaseUrl(baseUrl: string): boolean {
  const trimmed = baseUrl.trim()
  if (!trimmed) {
    return false
  }
  try {
    const { hostname } = new URL(trimmed)
    const h = hostname.toLowerCase()
    return h === 'localhost' || h === '127.0.0.1' || h === '[::1]'
  } catch {
    return /localhost|127\.0\.0\.1/i.test(trimmed)
  }
}

/** Heuristic: which backend process the base URL usually hits (Django vs api-ts). */
export function restApiStackHint(baseUrl: string): string {
  const trimmed = baseUrl.trim()
  if (!trimmed) {
    return ''
  }
  try {
    const { port } = new URL(trimmed)
    if (port === '8060') {
      return ' — HTTP Django (compose), pas api-ts ; postulat SPA → :3001 ou URL api-ts (.env.local)'
    }
    if (port === '3001') {
      return ' — HTTP api-ts local (habituel)'
    }
  } catch {
    // ignore
  }
  return ''
}

/** Logs once which API base URLs are active (local vs remote). */
export function logRestApiStartup(): void {
  const baseUrl = String(import.meta.env.VITE_APP_API_BASE_URL ?? '')
  const v1Url = String(import.meta.env.VITE_APP_API_V1_BASE_URL ?? '')
  const kind = isRestApiLocalBaseUrl(baseUrl) ? 'locale' : 'distante'
  const stack = restApiStackHint(baseUrl)
  // eslint-disable-next-line no-console
  console.info(
    `[Datagotchi] API ${kind}${stack} — VITE_APP_API_BASE_URL=${baseUrl || '(non définie)'} | VITE_APP_API_V1_BASE_URL=${v1Url || '(non définie)'} | VITE_APP_BUILD_ENV=${String(envName)}`,
  )
}

export const environment = {
  envName,
  isLocal: envName === EnvName.LOCAL,
  isDev: [EnvName.LOCAL, EnvName.DEV].includes(envName),
  isProd: [EnvName.PROD].includes(envName),
  restApi: {
    baseUrl: import.meta.env.VITE_APP_API_BASE_URL,
  },
  frontendBaseURL: import.meta.env.VITE_APP_BASE_HOSTNAME,
  googleAnalyticsTrackingCode: import.meta.env.VITE_GA_TRACKING_CODE,
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
    org: import.meta.env.VITE_SENTRY_ORG,
    project: import.meta.env.VITE_SENTRY_PROJECT,
  },
}

export default environment
